import { authHeader, config } from '../_helpers';

export const solrService = {
    getAll
};

var REQUEST_TIMEOUT_MS = 15000;
var MAX_RETRIES = 3;

function getAll(path, searchparam) {
    return fetchWithRetry(path, searchparam, 0);
}

function sanitizeDateFields(params) {
    var copy = Object.assign({}, params);
    // Only include date fields when PublicationDuration is "CPP" (custom period)
    var isCPP = copy.PublicationDuration === 'CPP';
    ['PublicationStartDate', 'PublicationEndDate'].forEach(function (field) {
        if (!isCPP) {
            delete copy[field];
            return;
        }
        var val = copy[field];
        if (val instanceof Date && !isNaN(val.getTime())) {
            copy[field] = val.toISOString();
        } else if (typeof val === 'string' && val !== '') {
            var parsed = new Date(val);
            if (!isNaN(parsed.getTime())) {
                copy[field] = parsed.toISOString();
            } else {
                delete copy[field];
            }
        } else {
            delete copy[field];
        }
    });
    return copy;
}

function fetchWithRetry(path, searchparam, attempt) {
    var sanitized = sanitizeDateFields(searchparam);
    var requestOptions = {
        method: 'POST',
        headers: { ...authHeader(), 'Content-Type': 'application/json' },
        body: JSON.stringify(sanitized)
    };

    var fetchPromise = fetch(config.solrApiUrl + '/' + path, requestOptions)
        .then(handleResponse, handleError);

    return timeoutPromise(REQUEST_TIMEOUT_MS, fetchPromise)
        .catch(function (err) {
            if (attempt < MAX_RETRIES - 1) {
                console.warn('Search request attempt ' + (attempt + 1) + ' failed: ' + (err && err.message || err) + '. Retrying...');
                return fetchWithRetry(path, searchparam, attempt + 1);
            }
            return Promise.reject(err);
        });
}

function handleResponse(response) {
    return new Promise(function (resolve, reject) {
        if (response.ok) {
            var contentType = response.headers.get("content-type");
            if (contentType && contentType.includes("application/json")) {
                response.json().then(function (json) { resolve(json); });
            } else {
                resolve();
            }
        } else {
            response.text().then(function (text) { reject(text); });
        }
    });
}

function handleError(error) {
    return Promise.reject(error && error.message);
}

function timeoutPromise(ms, promise) {
    return new Promise(function (resolve, reject) {
        var timeoutId = setTimeout(function () {
            reject(new Error("Request timed out after " + (ms / 1000) + " seconds"));
        }, ms);
        promise.then(
            function (res) {
                clearTimeout(timeoutId);
                resolve(res);
            },
            function (err) {
                clearTimeout(timeoutId);
                reject(err);
            }
        );
    });
}


// WEBPACK FOOTER //
// ./src/_services/solr.service.js